const state = {
  message: '',
  notificationsList: []
};

export default {
  state
};
